import { ThemeProvider, TextField } from "@mui/material";

export function SharedTextField({
  register,
  label,
  placeholder,
  extra,
  sx,
  dark,
}) {
  const lightStyle = {
    WebkitBoxShadow: "0 0 0 1000px white inset",
    WebkitTextFillColor: "#9747FF",
  };
  const darkStyle = {
    WebkitBoxShadow: "0 0 0 1000px #777 inset",
    WebkitTextFillColor: "#9747FF",
  };
  return (
    // <ThemeProvider>
    <TextField
      {...extra}
      {...register}
      placeholder={placeholder}
      label={label}
      size="small"
      focused
      inputProps={{
        style: dark ? darkStyle : lightStyle,
        min: extra?.min,
      }}
      sx={{
        "& .MuiFormLabel-root.Mui-focused": {
          color: "#22a770",
        },
        "& label": {
          left: "unset",
          right: "1.75rem",
          transformOrigin: "right",
          fontSize: "0.8rem",
          color: "#777",
        },
        "& legend": {
          textAlign: "right",
          fontSize: "0.6rem",
        },
        color: "#777",
        direction: "rtl",
        ...sx,
      }}
      InputProps={
        extra?.InputProps
          ? extra.InputProps
          : {
              style: {
                color: sx?.color ?? "#000",
              },
              placeholderStyle: {
                color: "#ffffff",
              },
            }
      }
    />
    // </ThemeProvider>
  );
}
